import { jsx as _jsx } from "react/jsx-runtime";
import { CustomTextField, ErrorIcon } from '../subcomponents';
import getTranslation from '../../../helpers/get-translation';
const DateOfBirthInput = ({ dateValue, error, handleOnChange, handleOnBlur }) => {
    const { birthDateHelpText, birthDatePlaceholder } = getTranslation();
    const onChange = (event) => {
        const { value } = event.target;
        handleOnChange(value);
    };
    return (_jsx(CustomTextField, { id: "birth-date", autoCapitalize: "none", name: "birth-date", placeholder: birthDatePlaceholder, helpText: birthDateHelpText, error: error, type: "text", value: dateValue, errorIcon: _jsx(ErrorIcon, {}), onChange: onChange, onBlur: handleOnBlur, width: 100, maxLength: 10 }));
};
export default DateOfBirthInput;
